// Prefer normalized _pricing.lines; fall back to preview.items
const getLines = (preview) =>
  (preview?.pricing?.lines && preview.pricing.lines.length
    ? preview.pricing.lines
    : preview?.items) || [];

const sumLine = (l) =>
  (typeof l.lineTotalExclTax === "number"
    ? l.lineTotalExclTax
    : l.lineSubtotal) || 0;

export function selectCakeTotal(preview) {
  const l = getLines(preview).find((x) => x.itemType === "cake");
  return l ? sumLine(l) : 0;
}

export function selectDessertsTotal(preview) {
  return getLines(preview)
    .filter((x) => x.itemType === "dessert")
    .reduce((s, x) => s + sumLine(x), 0);
}

export function selectRentalsTotal(preview) {
  return getLines(preview)
    .filter((x) => x.itemType === "rental")
    .reduce((s, x) => s + sumLine(x), 0);
}

export function selectDepositsTotal(preview) {
  return getLines(preview)
    .filter((x) => x.kind === "deposit")
    .reduce((s, x) => s + sumLine(x), 0);
}

export function selectDeliveryFee(preview) {
  console.log("preview is: ", preview);
  const l = getLines(preview).find(
    (x) => x.kind === "service" && /delivery/i.test(x.description || "")
  );
  return l ? sumLine(l) : 0;
}

export function selectSetupFee(preview) {
  const l = getLines(preview).find(
    (x) => x.kind === "service" && /setup/i.test(x.description || "")
  );
  return l ? sumLine(l) : 0;
}
